module.exports = __webpack_public_path__ + "img/coral2017-min.44f7b31c.jpg";